import {Expression, Parser} from 'expr-eval';
import {AreaChartData} from 'views/storyboard/charts/area/AreaChartWrapper';
import {BarChartData} from 'views/storyboard/charts/bar/BarChartWrapper';
import {LineChartData} from 'views/storyboard/charts/line/LineChartWrapper';
import {TableChartData} from 'views/storyboard/cellhandlers/TableCellHandler';


type ScalableChartData = (
    AreaChartData | BarChartData | LineChartData | TableChartData
    );

export const getScaledChartData = <T extends ScalableChartData>(
    data: T[],
    dataKeys: string[],
    scalingFactor?: string,
): T[] => {
    if (!scalingFactor || !scalingFactor.length) {
        return data;
    }

    // Validate scalingFactor to allow only valid characters for an expression
    const isValidScalingFactor = /^[0-9+\-*/().\s]*$/.test(scalingFactor);
    if (!isValidScalingFactor) {
        return data;
    }

    const parser = new Parser();
    let expr: Expression;

    try {
        expr = parser.parse(`count * (${scalingFactor})`);
    } catch {
        return data;
    }

    return data.map((el: T) => {
        const result: Partial<T> = {};

        const dataRowKeys = Object.keys(el) as Array<keyof T>;

        dataRowKeys.forEach((key: keyof T) => {
            const value = el[key];
            if (typeof value !== 'undefined') {
                if (dataKeys.includes(key.toString())) {
                    const evaluatedValue = expr.evaluate({count: el[key] as string | number});
                    result[key] = typeof evaluatedValue === 'number' ? parseFloat(evaluatedValue.toFixed(2)) : evaluatedValue;
                } else {
                    result[key] = el[key];
                }
            }
        });

        return result as T;
    });
};
